<template>
    <div>
        <profile-personal :data="user"
                          :btn-start-loading="startLoading" :btn-finish-loading="finishLoading"></profile-personal>
        <profile-company :data="user" :company-types="companyTypes" :sector-types="sectorTypes"
                         :btn-start-loading="startLoading" :btn-finish-loading="finishLoading"></profile-company>
        <profile-settings :data="user"
                          :btn-start-loading="startLoading" :btn-finish-loading="finishLoading"></profile-settings>
        <profile-password :password-description="passwordDescription"
                          :btn-start-loading="startLoading" :btn-finish-loading="finishLoading"></profile-password>
    </div>
</template>

<script>
    import ProfilePersonal from './ProfilePersonal'
    import ProfileCompany from './ProfileCompany'
    import ProfileSettings from './ProfileSettings'
    import ProfilePassword from './ProfilePassword'

    export default {
        components: {
            ProfilePersonal,
            ProfileCompany,
            ProfileSettings,
            ProfilePassword,
        },
        props: {
            user: Object,
            companyTypes: Object,
            sectorTypes: Object,
            passwordDescription: String,
        },
        methods: {
            startLoading(btn) {
                btn.disabled = true;
                btn.classList.add('btn-loading');
            },
            finishLoading(btn, success) {
                btn.classList.remove('btn-loading');

                // Re-enable submit button
                if (success) {
                    // Pause after success
                    setTimeout(() => btn.disabled = false, 2000);
                } else {
                    btn.disabled = false;
                }
            }
        }
    }

</script>